module.exports = __webpack_public_path__ + "38682f06a0b46112150759f57abfbc66.svg";